import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from "../../../../../core/auth/auth.service";
import {NotifyService} from "@services/notify.service";
import {getIdentifierAutomatizedTest, getIdentifierTestQa} from "../../../../../core/auth/automated-test-identifier";

@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['../../login.component.scss'],
    standalone: false
})
export class WelcomeComponent implements OnInit {

  @ViewChild('inputIdentify') inputIdentify!: ElementRef;

  public isAtendimentoRoute: boolean = false;
  public isTestEnv: boolean = false;
  public isLoading: boolean = false;

  constructor(private authService: AuthService,
              private router: Router,
              private aRoute: ActivatedRoute,
              private notifyService: NotifyService) {
  }

  ngOnInit(): void {
    this.isAtendimentoRoute = this.aRoute.snapshot.data.isBackofficeRoute || false;
    this.isTestEnv = this.aRoute.snapshot.data.isTestEnv;
  }

  private getInputValue(): string {
    return this.inputIdentify?.nativeElement?.value;
  }

  private validateRouteTest(): boolean {
    const urlSegment: string[] = this.aRoute.snapshot.url.map(segment => segment.path);
    const inputValue: string = this.getInputValue();

    if (
      !(urlSegment.includes('qa-test') && inputValue === getIdentifierTestQa())
      && !(urlSegment.includes('teste-automatizado') && inputValue === getIdentifierAutomatizedTest())
    ) {
      this.notifyService.showError('Identificação de Automação', 'O valor do campo de identificação não é válido.');
      this.router.navigate(['/login/bem-vindo']);
      return false;
    }

    return true;
  }

  login() {
    this.isLoading = true;
    localStorage.setItem('provider', this.aRoute.snapshot.data.ssoIdentifier);

    if (this.isTestEnv && !this.validateRouteTest()) return;

    this.authService.startLoginFlow();
  }

  public firstAccess() {
    this.router.navigate(['/primeiro-acesso']);
  }

}
